module.exports = __webpack_public_path__ + "img/icon_kskcspslt.af11d813.png";